/**
 * Block.js
 * Flexbox block
 *
 * @class   Block
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import StylePropable from 'mixins/js/StylePropable.js';


export default React.createClass({

    mixins: [StylePropable],

    displayName: 'Block',

    proptypes: {
        // flex
        width: React.PropTypes.oneOfType([
            React.PropTypes.number,
            React.PropTypes.string
        ]),
        height: React.PropTypes.string,
        flexDirection: React.PropTypes.string,
        flexGrow: React.PropTypes.number,
        flexShrink: React.PropTypes.number,
        alignSelf: React.PropTypes.string, // auto | flex-start | flex-end | center
        order: React.PropTypes.number,
        className: React.PropTypes.string,
        padded: React.PropTypes.bool,
        margin: React.PropTypes.bool,
        minWidth: React.PropTypes.string,
        borderRight: React.PropTypes.bool,
        borderLeft: React.PropTypes.bool,
        borderTop: React.PropTypes.bool,
        borderBottom: React.PropTypes.bool,
        justifyContent: React.PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around']),
        overflowX: React.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'initial', 'inherit']),
        overflowY: React.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'initial', 'inherit']),
        flexBasis: React.PropTypes.string,
        name: React.PropTypes.string,
        onScroll: React.PropTypes.func
    },

    getDefaultProps(){
        return {
            onScroll: function() {}
        }
    },

    render() {
        let width;
        if (typeof this.props.width === 'number') {
            width = {flex: this.props.width};
        } else if (this.props.width) {
            width = {
                flexBasis: this.props.flexBasis ? this.props.flexBasis :this.props.width,
                width: this.props.width
            };
        } else {
            width = {flex: 1};
        }

        let styles = Object.assign(this.mergeAndPrefix({
            boxSizing: 'border-box',
            minWidth: this.props.minWidth,
            flexDirection: this.props.flexDirection || 'column',
            flexGrow: this.props.flexGrow || 0,
            flexShrink: this.props.flexShrink || 0,
            height: this.props.height || 'auto',
            overflowX: this.props.overflowX || 'initial',
            overflowY: this.props.overflowY || 'initial',
            justifyContent: this.props.justifyContent || 'flex-start',
            alignItems: this.props.alignItems || 'initial'
        }), this.mergeAndPrefix(width), this.props.style);

        let classes = ClassNames(this.props.className, {
            'lui-flexbox-block': true,
            'lui-padded': this.props.padded,
            'lui-margin': this.props.margin,
            'lui-border-right': this.props.borderRight,
            'lui-border-left': this.props.borderLeft,
            'lui-border-top': this.props.borderTop,
            'lui-border-bottom': this.props.borderBottom
        });

        return (
            <div className={classes} style={styles} name={this.props.name} onScroll={this.props.onScroll} >
                {this.props.children}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/flexbox/Block.js
 **/